import { Injectable } from '@angular/core';
import moment from 'moment/moment';
import {
  SharedDocument,
  SharedDocumentProps,
} from 'src/app/data/document/domain/shared_document/shared_document';
import { SharedDocumentCommands } from 'src/app/data/document/domain/shared_document/shared_document_commands';
import { SharedDocumentUpload } from 'src/app/data/document/domain/shared_document/shared_document_upload';
import { Patient } from 'src/app/data/patient/domain/patient';

import { ScheduledTaskCommands } from '../../../data/dietitian/domain/scheduled_task/scheduled_task_commands';
import { InvalidScheduledTaskDateException } from '../../../data/dietitian/domain/scheduled_task/scheduled_task_exceptions';
import { PatientCommands } from '../../../data/patient/domain/patient_commands';

@Injectable()
export class SharedDocumentUploadModalFacade {
  isLoading = false;

  constructor(
    private sharedDocumentCommands: SharedDocumentCommands,
    private patientCommands: PatientCommands,
    private scheduledTaskCommands: ScheduledTaskCommands,
  ) {
    // do nothing
  }

  refreshPatient(patientId: string) {
    return this.patientCommands.setPatientState(patientId);
  }

  uploadSharedDocument(
    sharedDocumentProps: SharedDocumentProps,
    documentId?: string,
  ): SharedDocumentUpload {
    return this.sharedDocumentCommands.uploadSharedDocument(
      sharedDocumentProps,
      documentId,
    );
  }

  cancelSharedDocumentUpload(upload: SharedDocumentUpload): Promise<void> {
    return this.sharedDocumentCommands.cancelSharedDocumentUpload(upload);
  }

  createSharedDocuments(
    patient: Patient,
    sharedDocumentProps: SharedDocumentProps[],
  ): Promise<SharedDocument[]> {
    return this.sharedDocumentCommands.createSharedDocuments(
      patient,
      sharedDocumentProps,
    );
  }

  async scheduleSharedDocuments(
    scheduledDate: Date | undefined,
    scheduledTime: string | undefined,
    sharedDocumentProps: SharedDocumentProps[],
  ) {
    let scheduledAt: moment.Moment | undefined;
    if (scheduledDate && scheduledTime) {
      // merging date and time
      scheduledAt = moment(scheduledDate).startOf('day');
      const time = moment(scheduledTime, 'HH:mm');
      scheduledAt.set({
        hours: time.hours(),
        minutes: time.minutes(),
      });
    }
    if (scheduledAt) {
      await this.scheduledTaskCommands.scheduleSharedDocuments(
        scheduledAt.toDate(),
        sharedDocumentProps,
      );
    } else {
      throw new InvalidScheduledTaskDateException();
    }
  }
}
